import React from "react";
import {
  Drawer,
  Button,
  Typography,
  IconButton,
} from "@material-tailwind/react";
import FilterSection from "./FilterSection";

export function FilterModal({
  open = true,
  onClose,
  onOpen,
  onSelect,
  selectedFilter = {},
  dark = false,
  onResetAll,
  totalResultsCount,
}) {
  const closeDrawer = () => {
    onClose();
  };

  const activeCount = Object.keys(selectedFilter || {}).filter(
    (k) => selectedFilter[k] && selectedFilter[k].id && selectedFilter[k].id !== "all"
  ).length;

  return (
    <Drawer
      overlayProps={{
        className: "fixed inset-0 bg-black/70 backdrop-blur-sm z-50",
      }}
      placement="right"
      open={open}
      aria-disabled
      onClose={closeDrawer}
      className={`p-0 min-h-screen h-full flex flex-col justify-between transition-colors duration-300 z-50 w-full max-w-sm sm:max-w-md ${
        dark ? "bg-zinc-950 text-white border-l border-zinc-800" : "bg-white text-gray-900"
      }`}
    >
      {/* Sticky Modal Header */}
      <div className={`p-4 border-b flex items-center justify-between sticky top-0 z-20 backdrop-blur-md ${
        dark ? "bg-zinc-950/90 border-zinc-800" : "bg-white/90 border-gray-200"
      }`}>
        <div className="flex items-center gap-2.5">
          <Typography variant="h5" color={dark ? "white" : "blue-gray"} className="font-bold text-lg">
            Filter & Refine
          </Typography>
          {activeCount > 0 && (
            <span className="text-[11px] font-extrabold px-2 py-0.5 rounded-full bg-secondary text-white shadow-sm">
              {activeCount} active
            </span>
          )}
        </div>
        <IconButton
          variant="text"
          color={dark ? "white" : "blue-gray"}
          onClick={closeDrawer}
          className="rounded-full w-8 h-8 p-0 flex items-center justify-center hover:bg-zinc-800"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </IconButton>
      </div>

      {/* Scrollable Filter Content */}
      <div className="p-4 flex-1 overflow-y-auto scrollbar-thin">
        <FilterSection
          selectedFilter={selectedFilter}
          onSelect={onSelect}
          heading={false}
          dark={dark}
        />
      </div>

      {/* Sticky Bottom Action Bar */}
      <div className={`p-4 border-t sticky bottom-0 z-20 backdrop-blur-md flex items-center gap-3 ${
        dark ? "bg-zinc-950/95 border-zinc-800" : "bg-white/95 border-gray-200"
      }`}>
        {onResetAll && (
          <button
            onClick={onResetAll}
            className={`px-4 py-2.5 rounded-xl text-xs font-bold border transition-all active:scale-95 ${
              dark
                ? "border-zinc-800 hover:border-zinc-700 text-zinc-300 hover:text-white bg-zinc-900/60"
                : "border-gray-300 text-gray-700 hover:bg-gray-100"
            }`}
          >
            Clear All
          </button>
        )}
        <button
          onClick={closeDrawer}
          className="flex-1 py-2.5 rounded-xl bg-secondary text-white font-bold text-xs sm:text-sm shadow-lg shadow-secondary/25 hover:bg-secondary/90 transition-all active:scale-95 flex items-center justify-center gap-1.5"
        >
          <span>Apply Filters</span>
          {totalResultsCount !== undefined && (
            <span className="bg-black/25 px-2 py-0.5 rounded-full text-[11px] font-black">
              {totalResultsCount} items
            </span>
          )}
        </button>
      </div>
    </Drawer>
  );
}
